export const providerIntegrations = ($http: HttpApi) => ({
  get: id => $http.$get(`/builder/provider_integrations/${id}`),
});
